import { render, staticRenderFns } from "./FulfillmentOrdersCounterChartNew.vue?vue&type=template&id=06e9ec20"
import script from "./FulfillmentOrdersCounterChartNew.vue?vue&type=script&lang=js"
export * from "./FulfillmentOrdersCounterChartNew.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentOrdersCounterChartNew.vue?vue&type=style&index=0&id=06e9ec20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports